/**
 * MaintenanceCtrl controller
 * Show maintenance message
 */

import {PROVIDERS_CONST} from 'app/core/constants'

// Different messages for different error codes
let messages = {}
/**
 * WrapperCtrl controller
 *
 * @class WrapperCtrl
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc controller
 * @name mwApp/common.controller:WrapperCtrl
 */
/* @ngInject */
export default function WrapperCtrl ($sce, $rootScope, $interval, $timeout, $http, keycloakAdapterSvc) {
  var vm = this
  vm.loadBody = function(){
    return !!(window.ENV.APP_KEYCLOAK_ENABLED)? keycloakAdapterSvc.isAuthorized(): true;
  }
}
